
import { LpDecisionResult } from '../../lp-evaluation/LpEvaluationResult';

/**
 * API model for:
 *   POST: /api/applications
 */
export class GraphAppPermissionRequestModel {

    constructor(resourceId: string, scopes: string[], roles: string[], justification: string, clientIsManagedIdentity: boolean = false) {
        this.resourceId = resourceId;
        this.scopes = scopes;
        this.roles = roles;
        this.justification = justification;
        this.clientIsManagedIdentity = clientIsManagedIdentity;
    }

    clientIsManagedIdentity: boolean;
    resourceId: string;
    scopes: string[];
    roles: string[];
    justification: string;

    /** AI least-privilege evaluation result — populated when the requester ran the evaluation before submitting. Null when skipped. */
    lpEvaluationResult?: LpDecisionResult | null;
}